/** Browser-safe payment lifecycle values mirrored by Prisma. */
export const PaymentTransactionStatus = {
    INFLIGHT: 'INFLIGHT', // Light blue: we don't know yet if the GW received our request
    ACCEPTED: 'ACCEPTED', // Dark blue: the GW confirmed receipt of our request
    DECLINED: 'DECLINED', // Purple: the GW explicitly declined authorization
    AUTHORIZED: 'AUTHORIZED', // Light green: the GW has authorized the transaction
    BATCHED: 'BATCHED', // Dark green: the GW has batched the transaction
    DEPOSITED: 'DEPOSITED', // Tan: the processor has deposited the funds on our account
    FAILED: 'FAILED', // Red: the GW rejected the transaction request
    VOIDED: 'VOIDED', // Pink: the transaction was voided by our request
    REFUNDED: 'REFUNDED', // Magenta: we refunded the customer, partially or fully
} as const;
export type PaymentTransactionStatus = keyof typeof PaymentTransactionStatus;

export const PaymentReconciliationStatus = {
    NEW: 'NEW',
    RECONCILED: 'RECONCILED',
    VERIFIED: 'VERIFIED',
    MUST_AMEND: 'MUST_AMEND',
    AMENDED: 'AMENDED',
    AMEND_VERIFIED: 'AMEND_VERIFIED',
} as const;
export type PaymentReconciliationStatus =
    (typeof PaymentReconciliationStatus)[keyof typeof PaymentReconciliationStatus];

export const PaymentTransactionLifecycleEventType = {
    PREFLIGHT_PAYMENT: 'PREFLIGHT_PAYMENT',
    BIN_LOOKUP: 'BIN_LOOKUP',
    SYNC_PAYMENT: 'SYNC_PAYMENT',
    VOID: 'VOID',
    REFUND: 'REFUND',
    GATEWAY_TRANSACTION_DETAILS: 'GATEWAY_TRANSACTION_DETAILS',
    RECONCILIATION: 'RECONCILIATION',
    BATCH: 'BATCH',
} as const;

export type PaymentTransactionLifecycleEventType =
    keyof typeof PaymentTransactionLifecycleEventType;
